import { render, staticRenderFns } from "./ViewCourse.vue?vue&type=template&id=cdedbd36"
import script from "./ViewCourse.vue?vue&type=script&lang=js"
export * from "./ViewCourse.vue?vue&type=script&lang=js"
import style0 from "./ViewCourse.vue?vue&type=style&index=0&id=cdedbd36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports